import { getPersonaPillSuggestionsInSearchTable } from './getPersonaPillSuggestionsInSearchTable';
export function getMultiPersonaHeaderData(tableViewId, selectedNode) {
    var pdlNode = selectedNode;
    if (pdlNode.type === 5 /* PrivateDistributionList */) {
        var _a = pdlNode.data, members = _a.members, displayName_1 = _a.displayName, pdlId = _a.pdlId, favoriteId = _a.favoriteId;
        var personas_1 = members.map(function (member) { return ({
            EmailAddress: member.emailAddress,
            Name: member.displayName,
        }); });
        return {
            displayName: displayName_1,
            personas: personas_1,
            pdlId: pdlId,
            favoriteId: favoriteId,
        };
    }
    // Search scenario
    var personaPills = getPersonaPillSuggestionsInSearchTable(tableViewId);
    // This is temporary way as it's not applicable for all the languages
    // Follow up task: https://msfast.visualstudio.com/FAST/_workitems/edit/251421
    var displayName = buildDisplayName(personaPills.map(function (persona) { return calculateFirstName(persona.DisplayName); }));
    var personas = personaPills.map(function (persona) { return ({
        EmailAddress: persona.EmailAddresses[0],
        Name: persona.DisplayName,
    }); });
    return {
        displayName: displayName,
        personas: personas,
    };
}
function buildDisplayName(names) {
    if (names.length > 2) {
        // 3 or more names - example "A, B, C and D"
        var lastIndex = names.length - 1;
        var allNamesExceptLast = names.slice(0, lastIndex).join(', ');
        return allNamesExceptLast + " & " + names[lastIndex];
    }
    if (names.length === 2) {
        return names.join(' & ');
    }
    // 1 name
    return names[0];
}
function calculateFirstName(displayName) {
    var firstName = '';
    var splitted = displayName.split(' ');
    if (splitted && splitted.length > 0) {
        firstName = splitted[0];
    }
    return firstName;
}
//# sourceMappingURL=getMultiPersonaHeaderData.js.map